/**
 * Vite environment variables, extracted to a separate module so they can be
 * mocked in Jest tests (which run in CJS mode and don't support import.meta).
 */
export const VITE_ENV = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? "/api",
  APP_VERSION: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev",
};
